import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
import { ObjectKeys } from './keys';
class ObjectInterface extends BuiltinInterface {
}
class ObjectValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'ObjectConstructor';
    }
}
class ObjectConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Object', new ObjectInterface());
    builtins.addValue('Object', new ObjectValue());
    builtins.addInterface('ObjectConstructor', new ObjectConstructorInterface());
    builtins.addGlobalMember('ObjectConstructor', 'keys', new ObjectKeys());
};

//# sourceMappingURL=index.js.map
